import { mount } from "utils";
import { StationPageWidget } from "../components/HydroWebPush/StationPageWidget";

mount(StationPageWidget, "station_page_widget");
